import { ADS_CONSENT_EVENTS, getAdsMarketingConsent } from '@/shared/lib/adsConsent';

import { post } from './requestMethods';

export const sendAdsActivity = async (url: string, data: object) => {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 500);
  const cancelWithoutConsent = () => {
    if (!getAdsMarketingConsent()) controller.abort();
  };
  ADS_CONSENT_EVENTS.forEach((name) => window.addEventListener(name, cancelWithoutConsent));
  try {
    await post<void>(url, { data, signal: controller.signal });
  } finally {
    window.clearTimeout(timeout);
    ADS_CONSENT_EVENTS.forEach((name) => window.removeEventListener(name, cancelWithoutConsent));
  }
};
